module.exports = __webpack_public_path__ + "img/music-right6.62de808f.png";